import routerOptions0 from "/home/homeyou/shc/build/build-headless/101573/app/router.options.ts";
import routerOptions1 from "/home/homeyou/shc/build/build-headless/101573/node_modules/@shc/nuxt-shc-base-layer/app/router.options.ts";
import routerOptions2 from "/home/homeyou/shc/build/build-headless/101573/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions2,
...routerOptions1,
...routerOptions0,
}